// Dark navy banner header used on every stones page, matching the look of
// other in-app pages like SGI Order Import / Quotation Engine.
// Rendered below StoneTabs (which is the sticky element); the page header
// itself scrolls with content for a cleaner experience.
// - icon + title + optional subtitle on the left.
// - children on the right for contextual action buttons.
export default function StonesHeader({ icon: Icon, title, subtitle, children, accent = 'teal' }) {
  const accentColor = {
    teal: 'text-teal-400',
    amber: 'text-amber-400',
    emerald: 'text-emerald-400',
    violet: 'text-violet-400',
    blue: 'text-blue-400',
  }[accent] || 'text-teal-400';

  return (
    <header className="bg-slate-900 text-white px-4 sm:px-6 py-3 border-b border-slate-800">
      <div className="flex items-center justify-between gap-3 max-w-[1400px] mx-auto">
        <div className="flex items-center gap-3 min-w-0">
          {Icon && <Icon size={20} className={`${accentColor} shrink-0`} />}
          <div className="min-w-0">
            <h1 className="text-sm sm:text-base font-semibold truncate tracking-wide" data-testid="stones-page-title">{title}</h1>
            {subtitle && <p className="text-slate-400 text-[11px] truncate mt-0.5">{subtitle}</p>}
          </div>
        </div>
        {children && <div className="flex items-center gap-2 shrink-0">{children}</div>}
      </div>
    </header>
  );
}
